// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rdg_b10aed75","table":"rdg_187dddf9","cell":"rdg_a137e516 rdg_3496d3ee","headCell":"rdg_79096050 rdg_3496d3ee","body":"rdg_9008aaf2"};